<template>
    <div class="well well--no-margin">
        <p v-if="answers.length == 0"
            class="no-answer"
        >
            {{ $t('predictors.details.popularPredictionsSoon') }}
        </p>
        <template v-else>
            <div v-for="(answer, index) of answers"
                :key="answer.id"
                class="answer"
            >
                <div class="answer__top">
                    <span>{{ answer.formattedAnswer }}</span>
                    <span>{{ `${pollGetAnswerPercentage(answer.percentage)}%` }}</span>
                </div>
                <progress-bar
                    :percentage="answer.percentage"
                    :progressBarColor="getPollAnswerColor(index)"
                    :showNumber="false"
                />
            </div>
        </template>
    </div>
</template>

<script>
// 3rd party
import {
    mapGetters,
} from 'vuex';

// Components
import progressBar from '@webapp/components/progress/progress-bar.vue';

// Mixins
import pollMixin from '@shared/mixins/poll-mixin.js';

// Shared modules
import {
    getPollAnswerColor,
} from '@shared/utils/poll-colors.js';

export default {
    name: 'popular-v2',
    components: {
        progressBar,
    },
    mixins: [pollMixin],
    props: {
        teamId: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapGetters('predictorPredictableSportEvents', ['getPopularAnswers']),

        answers() {
            return this.getPopularAnswers(this.teamId);
        },
    },
    methods: {
        getPollAnswerColor,
    },
};
</script>

<style lang="scss" scoped>
.answer {
    padding: 1.8rem 0 2.3rem 0;
    border-top: 2px solid $concrete-color;

    @include min-width(md) {
        padding: 0 0 2.7rem 0;
        border-top: initial;
    }

    &:first-child {
        padding: 0 0 1.8rem 0;
        border-top: initial;
    }

    &__top {
        display: flex;
        justify-content: space-between;
        font-family: Nunito;
        font-size: 1.3rem;
        font-weight: bold;
        color: $daintree-color;
    }
}

.no-answer {
    font-family: Nunito;
    font-size: 1.3rem;
    font-weight: bold;
    color: $daintree-color;
}
</style>